import { buildForm as bleuUiBuildForm } from "@bleu.builders/ui";
import { serialize } from "object-to-formdata";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Navigate,
  useActionData,
  useLoaderData,
  useNavigate,
} from "react-router";
import { useSubmit } from "react-router-dom";
import { Wizard } from "react-use-wizard";

import { useUser } from "#/contexts/UserContext";

import { OnboardingRadioGroup } from "./(components)/OnboardingRadioGroup";
import {
  OnboardingWizardStep,
  OnboardingWizardWrapper,
} from "./(components)/WizardForm";

const customFields = {
  onboarding_radio_group: OnboardingRadioGroup,
};

const buildForm = (fields, form, index = 0) => {
  return bleuUiBuildForm(fields, form, index, customFields);
};

type OnboardingWizardType = {
  defaultValues: Record<string, unknown>;
  fields: Array<{
    label: string;
    fields: Array<{
      name: string;
      type: string;
      label: string;
      options?: Array<{
        value: string;
        label: string;
      }>;
    }>;
  }>;
};

type OnboardingProps = {
  data: OnboardingWizardType;
};

export default function Onboarding() {
  const { data } = useLoaderData() as OnboardingProps;
  const { user } = useUser();
  const actionData = useActionData() as {
    data: { errors: object; success: boolean };
  };
  const navigate = useNavigate();
  const submit = useSubmit();

  if (user.has_completed_onboarding) {
    return <Navigate to="/" />;
  }

  useEffect(() => {
    if (actionData) {
      const { success } = actionData.data;
      if (success) {
        // force page reload to update user context
        navigate(0);
      }
    }
  }, [actionData]);

  const form = useForm({
    defaultValues: data.defaultValues,
  });

  const handleSubmit = async () => {
    const isValid = await form.trigger();
    if (!isValid) return;

    const values = form.getValues();

    const formData = serialize(values);
    submit(formData, { method: "post", encType: "multipart/form-data" });
  };

  return (
    <Wizard
      wrapper={
        // @ts-expect-error TS(2741) FIXME: Property 'children' is missing in type '{ steps: a... Remove this comment to see the full error message
        <OnboardingWizardWrapper steps={data.fields} form={form} />
      }
      startIndex={0}
    >
      {data.fields.map((step, idx) => {
        return (
          <OnboardingWizardStep key={idx} form={form} onSubmit={handleSubmit}>
            <div className="flex flex-wrap gap-5 min-h-40">
              {buildForm(step.fields, form)}
            </div>
          </OnboardingWizardStep>
        );
      })}
    </Wizard>
  );
}
